var _style, _circle, _circle2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.4 13.8",
    style: {
      enableBackground: "new 0 0 22.4 13.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EE0005;}\n\t.st1{fill:#F9A000;}\n\t.st2{fill:#FF6300;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    className: "st0",
    cx: 6.9,
    cy: 6.9,
    r: 6.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_205",
    className: "st1",
    cx: 15.5,
    cy: 6.9,
    r: 6.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1959",
    className: "st2",
    d: "M8.6,6.9c0,2.1,1,4.1,2.6,5.4c3-2.4,3.5-6.7,1.1-9.7c-0.3-0.4-0.7-0.8-1.1-1.1 C9.6,2.8,8.6,4.8,8.6,6.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.4f4f59da53bef01b423a00a62ca8a645.svg";
export { ForwardRef as ReactComponent };